<template >
    <div class="legacy-ticker-dialog" @click="_closeFavoritesWindow">
      <div class="modal-container favorites-modal-content" role="dialog" aria-modal="true" aria-label="Favoritos" @click.stop>
        <!-- Standard Modal Header -->
        <div class="modal-header">
            <div class="title-wrapper">
                <span class="material-icons-outlined header-icon">grade</span>
                <h3 class="modal-title">Favoritos</h3>
            </div>
            <button type="button" aria-label="Cerrar favoritos" class="modal-close-btn" @click="_closeFavoritesWindow()">
                <i class="material-icons">close</i>
            </button>
        </div>

        <!-- Standard Modal Body -->
        <div class="modal-body">
            <!-- Existing content goes here, wrapped in modal-body -->
            <div v-if="!isDeleting">
                <!-- List of workspaces -->
                <div class="list-container">
                    <div v-for="workspace in workspaces" :key="workspace.name" class="list-item clickable-item" @click="_findFavoritesStocksByName(workspace)">
                        <div v-if="currentlyEditing.name != workspace.name" class="item-content-wrapper">
                            <div class="workspace-selector">
                                <span class="material-icons-outlined star-icon" :style="{ color: workspace.color }">star</span>
                                <span class="item-text workspace-name-style">{{workspace.name}}</span>
                            </div>
                            <LegacyCollectionCounts compact :tickers="workspace.count === null ? '...' : workspace.count" :entries="workspace.entryCountStatus === 'ready' ? workspace.entryCount : workspace.entryCountStatus === 'error' ? '—' : '...'"
                              :title="workspace.entryCountStatus === 'error' ? 'No se pudo cargar el número de entradas' : 'Tickers distintos y entradas de esta carpeta'" />
                            <!-- Folder actions -->
                            <div v-if="!isEditing && !isCreating" class="item-actions">
                                <button
                          v-if="workspace.name != 'Favorites'"
                          @click.stop="_editWorkspacePrepare(workspace)"
                                :aria-label="'Editar ' + workspace.name" class="icon-button edit-icon">
                                    <i class="material-icons">edit</i>
                                </button>
                                <button
                          v-if="workspace.name != 'Favorites'"
                          @click.stop="_deleteWorkspacePrepare(workspace)"
                                :aria-label="'Eliminar ' + workspace.name" class="icon-button delete-icon">
                                    <i class="material-icons">delete</i>
                                </button>
                    </div>
                        </div>
                        <!-- Edit mode -->
                        <div v-else class="edit-input-wrapper" @keyup.enter="_editWorkspaceConfirm()" @keyup.esc="_editWorkspaceCancel()">
                            <button class="icon-button color-trigger-btn" @click.stop="_toggleColorGrid('edit', $event)">
                                <span class="material-icons-outlined star-icon" :style="{ color: editWorkspaceColor }">star</span>
                            </button>
                            <input 
                                type="text" 
                                class="vanilla-input edit-fav-input" 
                                v-model="editWorkspaceNewName" 
                                placeholder="Nuevo nombre" 
                                :maxlength="input_edit_favorites.length || 32"
                                ref="editFavInput"
                            />
                            <button aria-label="Confirmar" class="icon-button confirm-edit-btn" @click.stop="_editWorkspaceConfirm()">
                                <i class="material-icons">check</i>
                            </button>
                            <button aria-label="Cancelar edición" class="icon-button cancel-edit-btn" @click.stop="_editWorkspaceCancel()">
                                <i class="material-icons">close</i>
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Add/Create New Workspace Section -->
                 <hr v-if="!isCreating && !isEditing && _g_UserFeatures.permissions.extra_favorites > workspaces.length - 1"/>
                <div>
                     <div v-if="!isCreating && !isEditing" class="add-workspace-section">
                         <button 
                            class="action-btn secondary-btn add-workspace-btn" 
                            @click="_createWorkspacePrepare()" 
                            :disabled="!(_g_UserFeatures.permissions.extra_favorites > workspaces.length - 1)"
                            :title="_g_UserFeatures.permissions.extra_favorites > workspaces.length - 1 ? 'Añadir nuevo espacio' : 'Límite de espacios alcanzado'">
                             <i class="material-icons">add</i>
                             <span>Añadir espacio</span>
                         </button>
            </div>
                     <div v-else-if="isEditing">
                         <!-- Placeholder while editing another item -->
                </div>
                     <div v-else class="create-workspace-form" @keyup.enter="_createWorkspaceConfirm()" @keyup.esc="_createWorkspaceCancel()">
                         <button class="icon-button color-trigger-btn" @click.stop="_toggleColorGrid('create', $event)">
                             <span class="material-icons-outlined star-icon" :style="{ color: createWorkspaceColor }">star</span>
                         </button>
                         <input
                              type="text" 
                              class="vanilla-input create-fav-input" 
                              v-model="createWorkspaceNewName" 
                              placeholder="Nombre del espacio" 
                              :maxlength="input_favorites.length || 32"
                              ref="createFavInput"
                          />
                          <button aria-label="Confirmar" class="icon-button confirm-edit-btn" @click.stop="_createWorkspaceConfirm()">
                              <i class="material-icons">check</i>
                          </button>
                          <button aria-label="Cancelar edición" class="icon-button cancel-edit-btn" @click.stop="_createWorkspaceCancel()">
                              <i class="material-icons">close</i>
                          </button>
                     </div>
                    </div>
                </div>
            <!-- Delete Confirmation View -->
            <div v-else class="delete-confirm-view">
                <p class="delete-question-text">¿Está seguro que desea eliminar este listado de favoritos?</p>
                <div class="workspace-to-delete-info">
                    <span class="material-icons-outlined star-icon" :style="{ color: currentlyDeleting.color }">star</span>
                    <span class="workspace-name-delete">{{currentlyDeleting.name}}</span>
                </div>
                 <p class="delete-warning">
                  <i class="material-icons warning-icon">warning</i>
                  Esta acción no se puede deshacer.
                </p>
            </div>
        </div>

        <!-- Standard Modal Footer (only for delete confirmation) -->
        <div class="modal-footer" v-if="isDeleting">
             <button class="action-btn secondary-btn" @click="_deleteWorkspaceCancel()">Cancelar</button>
             <button class="action-btn delete-btn" @click="_deleteWorkspaceConfirm()">Eliminar</button>
        </div>

        <!-- Custom Color Grid Popup -->
        <div v-if="showColorGrid" class="color-grid-popup" :style="colorGridStyle" ref="colorGridPopup">
             <div v-for="(color, index) in gridColors" 
                  :key="index" 
                  class="color-grid-item" 
                  :style="{ backgroundColor: color }"
                  @click="_selectColor(color)">
             </div>
         </div>
    </div>
    </div>
</template>



<script>
import LegacyCollectionCounts from "../components/LegacyCollectionCounts.vue";
import { loadLegacyFavoriteFolderCounts } from "../api/legacyFinderRepository";
import { legacyQueryConsumer } from "@/features/stockchart/models/legacyQuerySelection";
import { navigateLegacyQuery } from "@/features/stockchart/services/legacyQueryActivation";
// import VSwatches from 'vue-swatches';
// import "vue-swatches/dist/vue-swatches.css";
import APICaller from "@/shared/mixins/APICaller.js";
import inputFavorites from '@/features/stockchart/components/configs/favorites-workspace.json';
import inputEditFavorites from '@/features/stockchart/components/configs/edit-favorites-workspace.json';
import { mapMutations, mapGetters } from "vuex";

export default {
    mixins: [legacyQueryConsumer, APICaller],
    components: {
        LegacyCollectionCounts,
    },
    name: 'Favoritos',
    props: {},

    data: () => ({
        input_favorites : inputFavorites,
        input_edit_favorites : inputEditFavorites,
        workspaces: [],
        isClosingShieldOn: false,
        isCreating: false,
        isDeleting: false,
        isEditing: false,
        createWorkspaceNewName: "",
        editWorkspaceNewName: "",
        currentlyDeleting: {},
        currentlyEditing: {},
        createWorkspaceColor: "#35add8",
        editWorkspaceColor: "#000000",
        initialized: false,
        folderCountsRevision: 0,
        // Remove colorSwatches defined for v-swatches
        // colorSwatches: [ ... ],

        // --- Custom Color Grid Data ---
        showColorGrid: false,
        colorGridTarget: null, // 'create' or 'edit'
        colorGridStyle: {}, // For position { top: 'px', left: 'px' }
        // Define 16 grid colors
        gridColors: [
            "#ff0000", "#ff6000", "#ffbf00", "#dfff00", "#80ff00", "#20ff00", "#00ff40", "#00ff9f", "#00ffff", "#009fff", "#0040ff", "#2000ff", "#8000ff", "#df00ff", "#ff00bf", "#ff0060"
        ],
        // -------------------------------
        
        // Properties needed for _findFavoritesStocksByName
        workspace: null,
        numberStocks: 0,
    }),

    watch: {},
    computed: {
        ...mapGetters(["_g_UserFeatures"]),
        ...mapGetters(["_g_IsUserLogged"]),
    },

    created() {},

    mounted() {
        this._initWorkspaces();
        // Add event listeners for closing the grid
        document.addEventListener('click', this._handleClickOutside, true);
        window.addEventListener('resize', this._handleResize);
    },

    beforeDestroy() {
        // Clean up event listeners
        document.removeEventListener('click', this._handleClickOutside, true);
        window.removeEventListener('resize', this._handleResize);
    },

    methods: {
        ...mapMutations(["setWorkspaceCreated"]),
        ...mapMutations(['setSelectedFavoriteWorkspace']),

        _closeFavoritesWindow: function() {
            this.showColorGrid = false; // Ensure grid is closed
            this._cancelOngoingOperations();
            this.$emit('_closeFavoriteWorkspacesWindow');
        },

        // --- Custom Color Grid Methods ---
        _toggleColorGrid(context, event) {
            // If already shown for the same context, hide it
            if (this.showColorGrid && this.colorGridTarget === context) {
                this.showColorGrid = false;
                return;
            }

            // Find the button element that was clicked
            const triggerButton = event.target.closest('button');
            if (!triggerButton) {
                console.error("Could not find trigger button for color grid.");
                return; // Should not happen
            }

            // Get positions directly with client coordinates
            const buttonRect = triggerButton.getBoundingClientRect();
            
            // Direct approach: position directly next to the button
            // We'll use fixed positioning to bypass any container positioning issues
            
            // Get viewport dimensions
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;
            
            // Grid dimensions
            const gridWidth = 130; // Approximate grid width
            const gridHeight = 130; // Approximate grid height
            
            // Calculate position (prefer right side of button)
            let posLeft = buttonRect.right + 8; // 8px spacing
            let posTop = buttonRect.top;
            
            // If it would go off the right edge of the viewport, position left of the button
            if (posLeft + gridWidth > viewportWidth) {
                posLeft = buttonRect.left - gridWidth - 8;
            }
            
            // If it would still go off the left edge, position below or above
            if (posLeft < 0) {
                posLeft = buttonRect.left;
                posTop = buttonRect.bottom + 8;
                
                // If it would go off the bottom, position above
                if (posTop + gridHeight > viewportHeight) {
                    posTop = buttonRect.top - gridHeight - 8;
                }
            }
            
            // Final boundary checks
            posLeft = Math.max(8, Math.min(posLeft, viewportWidth - gridWidth - 8));
            posTop = Math.max(8, Math.min(posTop, viewportHeight - gridHeight - 8));
            
            // Apply styles using fixed positioning relative to viewport
            this.colorGridStyle = {
                position: 'fixed',
                top: `${posTop}px`,
                left: `${posLeft}px`,
            };

            // Set target context and show the grid
            this.colorGridTarget = context;
            this.showColorGrid = true;

            // Focus the first color item for accessibility
            this.$nextTick(() => {
                const firstColorItem = this.$refs.colorGridPopup?.querySelector('.color-grid-item');
                if (firstColorItem) {
                    firstColorItem.setAttribute('tabindex', '0');
                    firstColorItem.focus();
                }
            });
        },

        _selectColor(color) {
            if (this.colorGridTarget === 'create') {
                this.createWorkspaceColor = color;
            } else if (this.colorGridTarget === 'edit') {
                this.editWorkspaceColor = color;
            }
            this.showColorGrid = false;
        },

        _handleClickOutside(event) {
             if (this.showColorGrid && this.$refs.colorGridPopup && !this.$refs.colorGridPopup.contains(event.target)) {
                 // Check if the click was specifically outside the grid popup
                 // And also not on one of the trigger buttons
                 const isTrigger = event.target.closest('.color-trigger-btn');
                 if (!isTrigger) {
                     this.showColorGrid = false;
                 }
             }
        },

        _handleResize() {
            if (this.showColorGrid) {
                this.showColorGrid = false;
            }
        },
        // -------------------------------

        _initWorkspaces: function() {
             const revision = ++this.folderCountsRevision;
             this.initialized = false; // Reset flag
            let success = response => {
                if (this._isDestroyed || revision !== this.folderCountsRevision) return;
                this.workspaces = [];
                if (response.data && response.data.folders) {
                     for (let index = 0; index < response.data.folders.length; index++) {
                        this.workspaces.push({
                            name: response.data.folders[index][0],
                            color: response.data.folders[index][1],
                            count: response.data.folders[index][2] !== undefined ? response.data.folders[index][2] : null,
                            entryCount: response.data.folders[index][2] === 0 ? 0 : null,
                            entryCountStatus: response.data.folders[index][2] === 0 ? 'ready' : 'loading'
                        });
                    }
                } else {
                    console.error("Invalid response structure for folders:", response.data);
                    this.workspaces = [];
                }
                this.initialized = true;
                loadLegacyFavoriteFolderCounts(this.workspaces, (workspace, counts) => {
                    if (counts) workspace.count = counts.ticker_count;
                    workspace.entryCount = counts ? counts.entry_count : null;
                    workspace.entryCountStatus = counts ? 'ready' : 'error';
                }, () => !this._isDestroyed && revision === this.folderCountsRevision);
            };

            let url = '/api/v1/stock-finder/favorite-folder/list';
            
            const successHandler = new APICaller.SuccessHandler(success);
            const failureHandler = new APICaller.FailureHandler('229', 'Error recuperando la lista de favoritos.');

            this._getAPICall(url, successHandler, failureHandler);
        },

        _createWorkspacePrepare: function() {
            if(this.workspaces && this._g_UserFeatures.permissions.extra_favorites > this.workspaces.length - 1){
                this._editWorkspaceCancel();
                this._deleteWorkspaceCancel();
                this.createWorkspaceColor = this.gridColors[Math.floor(Math.random() * this.gridColors.length)]; // Use grid colors
                this.isCreating = true;
            }else{
                 let toast = {type: 'warning', body: 'Con su plan actual no puede crear más espacios de trabajo. PULSE AQUÍ para mejorar su plan.', clickHandler: function(){
                   window.location.replace("/app/store");
                 }};
                 this.$vueOnToast.pop(toast);
            }
        },

        _createWorkspaceConfirm: function() {
            const newName = this.createWorkspaceNewName.trim();
            if(newName !== '') {
                let params = new URLSearchParams();
                params.append('name', newName);
                params.append('color', this.createWorkspaceColor);

                let url = '/api/v1/stock-finder/favorite-folder/create';

                let success = (response) =>{
                    if (response.data?.status === 'error') {
                        this.$vueOnToast.pop('error', "Error", response.data.message || 'No se pudo crear el espacio.');
                    } else {
                         this.$vueOnToast.pop('success', "Espacio de trabajo " + newName, "creado con éxito");
                         this._initWorkspaces();
                         this.setWorkspaceCreated(true);
                    }
                     this._createWorkspaceCancel();
                };

                 let failure = () => {
                    this._createWorkspaceCancel();
                 };

                const successHandler = new APICaller.SuccessHandler(success);
                const failureHandler = new APICaller.FailureHandler('304', 'Error creando el espacio de trabajo.', failure);

                this._postAPICall(url, params, successHandler, failureHandler);
            } else {
                 this.$vueOnToast.pop('error', "Error", "El nombre no puede estar vacío.");
            }
        },

        _createWorkspaceCancel: function() {
            this.isCreating = false;
            this.createWorkspaceNewName = "";
            this.showColorGrid = false;
        },

        _deleteWorkspacePrepare: function(workspace) {
            this._editWorkspaceCancel();
            this._createWorkspaceCancel();
            this.isDeleting = true;
            this.currentlyDeleting = workspace;
        },

        _deleteWorkspaceConfirm: function() {
             if (!this.currentlyDeleting || !this.currentlyDeleting.name) return;

            let params = new URLSearchParams();
            params.append('name', this.currentlyDeleting.name);

            let url = '/api/v1/stock-finder/favorite-folder/delete';
            let deletedName = this.currentlyDeleting.name;

            let success = (response) => {
                 if (response.data?.status === 'error') {
                        this.$vueOnToast.pop('error', "Error", response.data.message || 'No se pudo eliminar el espacio.');
                 } else {
                    this.$vueOnToast.pop('success', "Espacio de trabajo " + deletedName, "eliminado con éxito");
                    this._initWorkspaces();
                    this.setWorkspaceCreated(true);
                 }
                 this._deleteWorkspaceCancel();
            };

            let failure = () => {
                this._deleteWorkspaceCancel();
            };

            const successHandler = new APICaller.SuccessHandler(success);
            const failureHandler = new APICaller.FailureHandler('305', 'Error borrando espacio de trabajo.', failure);

            this._postAPICall(url, params, successHandler, failureHandler);
        },

        _deleteWorkspaceCancel: function() {
            this.isDeleting = false;
            this.currentlyDeleting = {};
            this.showColorGrid = false;
        },

        _editWorkspacePrepare: function(workspace) {
            this._createWorkspaceCancel();
            this._deleteWorkspaceCancel();
            this.isEditing = true;
            this.currentlyEditing = { ...workspace };
            this.editWorkspaceNewName = workspace.name;
            this.editWorkspaceColor = workspace.color;
        },

        _editWorkspaceConfirm: function() {
            const newName = this.editWorkspaceNewName.trim();
            const originalName = this.currentlyEditing.name;
            const newColor = this.editWorkspaceColor;
            const originalColor = this.currentlyEditing.color;

            if (newName === '') {
                this.$vueOnToast.pop('error', "Error", "El nombre no puede estar vacío.");
                return;
            }

            if (newName === originalName && newColor === originalColor) {
                this.$vueOnToast.pop('info', "Info", "No se realizaron cambios.");
                this._editWorkspaceCancel();
                return;
            }

            var params = new URLSearchParams();
            params.append('name', originalName);
            params.append('new_name', newName);
            params.append('new_color', newColor); // Added new_color parameter

            let url = '/api/v1/stock-finder/favorite-folder/update';

            let success = (response) => {
                if (response.data?.status === 'error') {
                    this.$vueOnToast.pop('error', "Error", response.data.message || 'No se pudo editar el espacio.');
                } else {
                    this.$vueOnToast.pop('success', "Espacio de trabajo " + newName, "editado con éxito");
                    
                    // First cancel the editing mode to clear any popovers or state
                    this._editWorkspaceCancel();
                    
                    // THEN refresh workspaces list
                    this._initWorkspaces();
                    
                    // THEN emit the event to update colors in stock list
                    this.$nextTick(() => {
                        this.$emit("workspace_edited");
                    });
                }
            };

            let failure = () => {
                this._editWorkspaceCancel();
            };

            const successHandler = new APICaller.SuccessHandler(success);
            const failureHandler = new APICaller.FailureHandler('306', 'Error guardando cambios.', failure);

            this._postAPICall(url, params, successHandler, failureHandler);
        },

        _editWorkspaceCancel: function() {
            this.isEditing = false;
            this.editWorkspaceNewName = "";
            this.currentlyEditing = {};
            this.showColorGrid = false;
        },

        _cancelOngoingOperations: function() {
            this.isCreating = false;
            this.isDeleting = false;
            this.isEditing = false;
            this.currentlyDeleting = {};
            this.currentlyEditing = {};
            this.createWorkspaceNewName = "";
            this.editWorkspaceNewName = "";
            this.showColorGrid = false;
        },

        _manageExitClicksBehavior: function() {
             console.warn("_manageExitClicksBehavior might be redundant");
        },
        _turnOnClosingShield: function() {
            this.isClosingShieldOn = true;
        },

        _findFavoritesStocksByName: function(workspace) {
            // workspace object now has name, color, and count
            if (workspace.count > 0) {
                this.setSelectedFavoriteWorkspace(workspace.name);
                if (this.$router.history.current.name === 'Favoritos') {
                    this.$vueOnToast.pop('warning', "Ya estás en favoritos");
                } else {
                    navigateLegacyQuery(this, '/app/graficador-dinamico/favorites/' + workspace.name);
                }
                // Close the modal after navigation
                this._closeFavoritesWindow();
            } else { // workspace.count is 0 or undefined
                if (this._g_IsUserLogged) { // Retain existing condition for showing messages
                    this.$vueOnToast.pop('info', "No hay tickers en esta carpeta.");
                }
                // Close the modal even when showing info message
                this._closeFavoritesWindow();
            }
        },

        _getStocksInWorkspace: function() {
            return new Promise((resolve, reject) => {
                let url = '/api/v1/stock-finder/stocks/favoritos/' + this.workspace.name;
                
                let success = response => {
                    const stockCount = response.data.length;
                    this.numberStocks = stockCount;
                    resolve(stockCount);
                };
                
                let failure = error => {
                    this.numberStocks = 0;
                    reject(error);
                };

                const successHandler = new APICaller.SuccessHandler(success);
                const failureHandler = new APICaller.FailureHandler('307', 'Error recuperando el listado de valores.', failure);

                this._getAPICall(url, successHandler, failureHandler);
            });
        },
    },
}
</script>


<style lang="scss" scoped>
@import "../styles/legacy-ticker-dialogs.scss";
.legacy-ticker-dialog {
  .workspace-selector { overflow: hidden; }
  .legacy-collection-counts { flex-shrink: 0; }
  .star-icon { font-size: 20px; flex-shrink: 0; }
  .add-workspace-section { margin-top: 16px; }
  .secondary-btn:disabled { opacity: .6; cursor: not-allowed; }
  .color-grid-popup, .color-grid-item { border-radius: 0; }
  .color-grid-item { transform: none; box-shadow: none; }
  hr { border: 0; height: 1px; margin: 16px 0; background: var(--dialog-border); }
}
</style>
